export const GETTERS_LIST_BIOMETRIC_DATA = "GETTERS_LIST_BIOMETRIC_DATA";

export const ACTIONS_GET_LIST_BIOMETRIC_DATA =
  "ACTIONS_GET_LIST_BIOMETRIC_DATA";

export const MUTATIONS_SET_LIST_BIOMETRIC_DATA =
  "MUTATIONS_SET_LIST_BIOMETRIC_DATA";

export const LIST_BIOMETRIC_CATEGORIES = {
  SYSTOLIC_CODE: "BP_Systolic__c",
  DIASTOLIC_CODE: "BP_Diastolic__c",
  WAIST_CODE: "Waist__c",
  TC_CODE: "RCho__c",
  HDL_CODE: "RHdl__c",
  TRIGLYCERIDES_CODE: "RTrig__c",
  FAST_CODE: "RFpg__c",
  NON_FAST_CODE: "Non_Fasting_Y_N__c",
  A1C: "a1c",
  BMI_CODE: "BMI__c",
  TC_HDL_CODE: "TC_HDL_Ratio__c",
  BLOOD_PRESSURE_CODE: "WELLMETRIC_BLOOD_PRESSURE",
  CHOLESTEROL_CODE: "WELLMETRIC_CHOLESTEROL",
  GLUCOSE_CODE: "WELLMETRIC_GLUCOSE",
  HBC_CODE: "WELLMETRIC_BODY_COMPOSITION",
  TOBACCO_ATTESTATION: "WELLMETRIC_TOBACCO_ATTESTATION",
  TOBACCO_RAS: "WELLMETRIC_TOBACCO_RAS"
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_program_biometric_data/constants.js